import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import {
    required,
    email,
    minLength,
    maxLength,
    numeric
} from "vuelidate/lib/validators";
import axios from "axios";
import $ from "jquery";
import { mapGetters } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "contactUsNew",

    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            id: "",
            name: "",
            email: "",
            phone_number: "",
            detail_message: "",
            submitted: false
        };
    },

    mounted() {
        if (this.applicantToken != null) {
            this.name = this.applicantName || "";
            this.email = this.applicantEmail || "";
        }
    },

    validations: {
        name: {
            required,
            maxLength: maxLength(100)
        },
        email: {
            required, email
        },
        phone_number: {
            required,
            minLength: minLength(9),
            maxLength: maxLength(11),
            numeric
        },
        detail_message: {
            required,
            maxLength: maxLength(500)
        }
    },

    methods: {
        submit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.contactCreate();
        },

        contactCreate() {
            $("#block-btn").attr("disabled", true);
            this.isLoading = true;
            var request = {
                applicant_id: this.applicantId || null,
                name: this.name,
                email: this.email,
                phone_number: this.phone_number,
                detail_message: this.detail_message
            };
            axios.post("applicant/contact/create", request)
                .then(() => {
                    this.name = this.applicantToken != null ? this.applicantName : '';
                    this.email = this.applicantToken != null ? this.applicantEmail : '';
                    this.phone_number = '';
                    this.detail_message = '';
                    this.submitted = false;
                    this.isLoading = false;
                    this.$notification.success("အီးမေးလ်ကို အောင်မြင်စွာပို့ပြီးဖြစ်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch(error => {
                    $("#block-btn").attr("disabled", false);
                    this.$notification.error("Contact Adding Failed", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.isLoading = false;
                    console.log("contactCreate Error", error.errors);
                });
        }
    },

    computed: {
        ...mapGetters({
            applicantToken: "applicantToken",
            applicantId: "applicantId",
            applicantName: "applicantName",
            applicantEmail: "applicantEmail"
        })
    }
};